import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  action,
  icon = "📭",
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: string;
}) {
  return (
    <div className="card card-body flex flex-col items-center text-center gap-3 py-10">
      <div aria-hidden className="text-4xl select-none">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
      {description && <p className="text-sm text-slate-500 max-w-md">{description}</p>}
      {action}
    </div>
  );
}
